import React, {Fragment} from 'react';

class TextAreaRender extends React.Component {
	static defaultProps = {
		disabled: false,
		readOnly: false,
		className: '',
		addClassName: '',
		maxLength: 255
	};

	render() {
		const {id, input, placeholder, className, type, disabled, readOnly, autoComplete, meta} = this.props;
		return (
			<Fragment>
				<textarea
					{...input}
					id={id}
					placeholder={placeholder}
					autoComplete={autoComplete}
					className={className}
					type={type}
					disabled={disabled}
					readOnly={readOnly}
				/>
				{meta.error && meta.touched &&
					<div className='error text-danger'>{meta.error}</div>}
			</Fragment>
		);
	}
}

export default TextAreaRender;



// WEBPACK FOOTER //
// ./src/common/fields/renders/TextAreaRender.js